import { Component, OnInit } from '@angular/core';
import { SidebarService } from './sidebar.service'; // Adjust path

@Component({
  standalone: false,
	selector: 'app-sidebar-minimizer',
	templateUrl: './app-sidebar-minimizer.component.html',
})
export class AppSidebarMinimizerComponent implements OnInit {
	minimized = false;

	constructor(private sidebarService: SidebarService) {}

	ngOnInit() {
		this.sidebarService.minimized$.subscribe((min: any) => (this.minimized = min));
	}

	toggle() {
		this.sidebarService.toggleMinimized();
	}
}
